export default __webpack_public_path__ + "images/0xfcef8a994209d6916eb2c86cdd2afd60aa6f54b1.png";